module.exports = __webpack_public_path__ + "img/check-top.3463eb0f.svg";